<template>
  <div class="map-container">
    <div id="map"></div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl';

export default {
  name: 'LocationsMapBox',
  mounted() {
    this.initMap();
    this.$emit('isLoaded');
  },
  data() {
    return {
      map: null,
      draw: null,
      singleLocation: null,
      property: {},
      output: null,
      popup: new mapboxgl.Popup({focusAfterOpen: false})
    }
  },
  computed: {
  },
  props: {
    isLoading: {
      type: Boolean
    },
    location: {
      type: Function
    },
    locationsJson: {
      type: Object,
    },
    getSingleLocation: {
      type: Function
    },
  },
  watch: {
  },
  methods: {
    initMap() {
      mapboxgl.accessToken = process.env.VUE_APP_MAP_ACCESS_TOKEN;
      let zoom = 2
      let style = 'mapbox://styles/mapbox/light-v10?optimize=true'
      const coordinates = [this.locationsJson.features[0].geometry.coordinates[0], this.locationsJson.features[0].geometry.coordinates[1]]

      // Initiate map
      this.map = new mapboxgl.Map({
        container: 'map',
        style: style,
        center: coordinates,
        zoom: zoom,
      });

      const map =  this.map;

      this.map.on('load', () => {
        this.map.addControl(new mapboxgl.NavigationControl(), 'top-right');
        this.map.addControl(
          new mapboxgl.ScaleControl({
            maxWidth: 100,
            unit: 'metric',
          }),
        );

        document.querySelector('.location-modal-trigger').addEventListener('click', function(){
          map.resize();
        });

        const el = document.querySelector("a[href='#branch-locations']")

        if (el) {
          el.addEventListener('click', function(e) {
            map.resize();
          });
        }

        this.map.addSource('locations', {
          type: 'geojson',
          // Point to GeoJSON data. This example visualizes all M1.0+ locations
          data: this.locationsJson,
          cluster: true,
          clusterMaxZoom: 14, // Max zoom to cluster points on
          clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
        });

        this.map.addLayer({
          id: 'location-clusters',
          type: 'circle',
          source: 'locations',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': [
              'step',
              ['get', 'point_count'],
              '#00539C',
              50,
              '#00539C',
              750,
              '#00539C',
            ],
            'circle-radius': [
              'step',
              ['get', 'point_count'],
              20,
              100,
              30,
              750,
              40,
            ],
          },
        });

        this.map.addLayer({
          id: 'location-cluster-count',
          type: 'symbol',
          source: 'locations',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count_abbreviated}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 12,
          },
          paint: {
            'text-color': '#ffffff',
          }
        });

        this.map.addLayer({
          id: 'location-unclustered-point',
          type: 'circle',
          source: 'locations',
          filter: ['!', ['has', 'point_count']],
          paint: {
            'circle-color': '#00539C',
            'circle-radius': 10,
            'circle-stroke-width': 1,
            'circle-stroke-color': '#fff',
          },
        });

        // Click events
        this.map.on('click', 'location-unclustered-point', (e) => {

          this.featurePopup(e, 'location')
          this.map.flyTo({
            center: e.features[0].geometry.coordinates
          });
        });

        // Click events
        this.map.on('touchend', 'location-unclustered-point', (e) => {
          this.featurePopup(e, 'location')
          this.map.flyTo({
            center: e.features[0].geometry.coordinates
          });
        });

        // inspect a cluster on click
        this.map.on('click', 'location-clusters', (e) => {
          this.doInspectCluster(e, 'location')
        });

        // inspect a cluster on touch
        this.map.on('touchend', 'location-clusters', (e) => {
          this.doInspectCluster(e, 'location')
        });

        // Set cursor styles
        this.map.on('mouseenter', 'location-clusters', () => {
          this.map.getCanvas().style.cursor = 'pointer';
        });

        // Set cursor styles
        this.map.on('mouseleave', 'location-clusters', () => {
          this.map.getCanvas().style.cursor = '';
        });
      });
    },
    doInspectCluster(e, type) {
      let layer = null;
      let source = null;

      if (type === 'location') {
        layer = 'location-clusters';
        source = 'locations';
      }

      const features = this.map.queryRenderedFeatures(e.point, {
          layers: [layer],
      });

      const clusterId = features[0].properties.cluster_id;

      this.map.getSource(source).getClusterExpansionZoom(
        clusterId,
        (err, zoom) => {
          if (err) return;
          this.map.easeTo({
            center: features[0].geometry.coordinates,
            zoom,
          });
        },
      );
    },
    doLocationAddress(location) {
      let locationAddress = location.location_address[0];
      let locationSuburb = location.location_suburb[0];
      let locationCity = location.location_city[0];
      let locationState = location.location_region[0];
      let locationPostCode = location.location_post_code[0];
      if ( locationAddress ) {

        let fullAddress = locationAddress

        if (locationSuburb ) {
          fullAddress = fullAddress + ', ' + locationSuburb;
        }

        if (locationCity) {
          fullAddress = fullAddress + ', ' + locationCity;
        }

        if (locationState) {
          fullAddress = fullAddress + ', ' + locationState;
        }

        if (locationPostCode) {
          fullAddress = fullAddress + ', ' + locationPostCode;
        }
        return fullAddress;
      }
    },
    doLoadingPopUp(coordinates) {
      this.output = `<div class="card loading-pop-up"> </div>`;
      this.popup
        .setLngLat(coordinates)
        .setHTML(this.output)
        .addTo(this.map);
      return this.output;
    },
    async featurePopup(feature, type) {
      const coordinates = feature.features[0].geometry.coordinates.slice();
      this.doLoadingPopUp(coordinates);
      let output
      const res = async () => {
        await this.getSingleLocation(feature.features[0], type)
          .then(res => {
            this.location = res;
            let fullAddress = this.doLocationAddress(this.location.metadata)
            let email = this.location.metadata.location_email[0]
            let phone = this.location.metadata.location_phone[0]
            output = `
              <div class="card">
                  <article id="location-16134" class="entry current post-16134 location type-location status-publish" tab-index="0">
                    <div class="entry-link">
                      <div class="entry-wrapper">

                        <div class="entry-preview">
                          <div class="entry-preview-content">

                            <div class="title-wrap">
                              <h2 class="title h5">${this.location.title.rendered}</h2>
                              <span class="subtitle"><span class="venue-address">${fullAddress}</span></span>
                            </div>
                        <div class="contact-details">`;
                        output = ( phone ? output + `
                              <div class="contact-group phone">
                                <div class="group-label">
                                  <span class="label"> Phone</span>
                                </div>
                                <a href="tel: ${phone}}">${phone}</a>
                              </div>` : output );
                        output = ( email ? output + `
                              <div class="contact-group email">
                                <div class="group-label">
                                  <span class="label"> Email</span>
                                </div>
                                  <a href="mailto:${email} ">${email}</a>
                                </div>`  : output );
                        output =  output + `
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            `;
            this.output = output;
            this.popup
            .setLngLat(coordinates)
            .setHTML(this.output)
            .addTo(this.map);
          return this.output;
          });
        }
      return res();
    },
  },
};
</script>

<style>

#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}
</style>
